import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';


@Component({
    selector: 'soft-chip',
    imports: [],
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent {
  @Input() canDelete = false;
  @Output() delete = new EventEmitter<this>();
}
